import { useState, useRef, useCallback } from 'react';
import type { Rect, ContextMenuData } from '../types';

export const useContextMenu = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [contextMenu, setContextMenu] = useState<ContextMenuData | null>(null);

  const handleContextMenu = useCallback((
    e: React.MouseEvent,
    target: string,
    type: ContextMenuData['type'],
    options?: string[],
    isCompendium?: boolean
  ) => {
    e.preventDefault();
    
    // We rely entirely on the 'options' passed from App.tsx (which come from data.json)
    // If no options are passed, we default to an empty array to avoid errors.
    let menuOptions: string[] = options || [];

    if (isCompendium && type === 'knight') {
        menuOptions = [target];
    }

    const el = e.currentTarget as HTMLElement | null;
    const rect = el?.getBoundingClientRect();
    
    setContextMenu({
      x: e.clientX,
      y: e.clientY,
      target,
      type,
      options: menuOptions,
      rect
    });
  }, []);

  const closeContextMenu = useCallback(() => setContextMenu(null), []);

  return {
    containerRef,
    contextMenu,
    handleContextMenu,
    closeContextMenu
  };
};
